export const GET_NEARBY_CITY = 'GET_NEARBY_CITY';
